import { MICRO_USD_PER_CREDIT } from '../constants'

const creditsNumberFormat = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 })

/** Whole grouped credits; a fraction rounds away from zero, so small charges never show as 0. */
export function formatCredits(microUsd: number): string {
  const credits = roundCreditsUp(microUsd)
  return `${creditsNumberFormat.format(credits)} ${Math.abs(credits) === 1 ? 'credit' : 'credits'}`
}

/** Compact form for dense usage lines. */
export function formatCreditsShort(microUsd: number): string {
  return `${creditsNumberFormat.format(roundCreditsUp(microUsd))} cr`
}

/** "500 credits expire on {date}", the verb agreeing with the displayed count. */
export function formatCreditsExpiring(microUsd: number, date: string): string {
  return `${formatCredits(microUsd)} ${roundCreditsUp(microUsd) === 1 ? 'expires' : 'expire'} on ${date}`
}

export function formatCreditsSigned(microUsd: number): string {
  const prefix = microUsd >= 0 ? '+' : ''
  return `${prefix}${formatCredits(microUsd)}`
}

/** Exact value for editable inputs: saving a form must not apply display rounding. */
export function creditsInputValue(microUsd: number): string {
  return String(microUsd / MICRO_USD_PER_CREDIT)
}

/** Empty/invalid values stay distinct from zero; storage precision is one microUSD. */
export function parseCreditsToMicroUsd(credits: string | number): number | null {
  if (typeof credits === 'string' && credits.trim() === '') return null
  const amount = Number(credits)
  const microUsd = Math.round(amount * MICRO_USD_PER_CREDIT)
  return Number.isSafeInteger(microUsd) ? microUsd : null
}

function roundCreditsUp(microUsd: number): number {
  const magnitude = Math.ceil(Math.abs(microUsd) / MICRO_USD_PER_CREDIT)
  return microUsd < 0 ? -magnitude : magnitude
}
